function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 24px;\n\n  .header {\n    font-size: 16px;\n    font-weight: 500;\n  }\n  ",
        " {\n    margin-top: 20px;\n    height: 2px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import propTypes from "prop-types";
import styled from "styled-components";
import { WrRow as Row, WrCol as Col } from "../../../grid";
import PercentageBar from "./PercentageBar";
import AllocationDisplay from "./AllocationDisplay";
function PhaseSummary(props) {
    var label = props.label, hours = props.hours, cost = props.cost, parentHours = props.parentHours, noFraction = props.noFraction, children = props.children, rest = _objectWithoutProperties(props, [
        "label",
        "hours",
        "cost",
        "parentHours",
        "noFraction",
        "children"
    ]);
    var fraction = hours / (parentHours || 1);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", _extends({}, rest), /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
        xs: true,
        className: "header"
    }, label), /*#__PURE__*/ React.createElement(Col, {
        xs: true,
        $noGrow: true,
        className: "values"
    }, /*#__PURE__*/ React.createElement(AllocationDisplay, {
        hours: hours || 0,
        cost: cost
    }))), !noFraction && /*#__PURE__*/ React.createElement(PercentageBar, {
        fraction: fraction || 0,
        $rounded: true
    }), children));
}
var StPhaseSummary = styled(PhaseSummary)(_templateObject(), PercentageBar);
PhaseSummary.propTypes = {
    label: propTypes.string,
    hours: propTypes.number,
    cost: propTypes.number,
    parentHours: propTypes.number,
    index: propTypes.number,
    parentIndex: propTypes.number,
    noFraction: propTypes.bool,
    itemRows: propTypes.array,
    itemRowPositionsRef: propTypes.shape({
        current: propTypes.any
    })
};
export default StPhaseSummary;
